import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';

interface MyIconProps {
  type?: string;
  className?: string;
  style?: React.CSSProperties;
  spin?: boolean;
  rotate?: number;
  twoToneColor?: string;
  [key: string]: any;
}

const Component = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3774496_h6kwidnase.js'
});

const Component_Ticket = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_3774498_a1033uwygya.js'
});

const MyIcon = (props: MyIconProps): JSX.Element => {
  const { className, type, twoToneColor: _ignored, ...otherParams } = props;

  return <Component className={className} type={type!} {...otherParams} />;
};

MyIcon.Ticket = (props: MyIconProps): JSX.Element => {
  const { className, type, twoToneColor: _ignored, ...otherParams } = props;

  return <Component_Ticket className={className} type={type} {...otherParams} />;
};

MyIcon.defaultTypes = {
  type: '',
  className: ''
};

export default MyIcon;
